import React from 'react'
import { useSelector } from 'react-redux'
import Form from 'antd/lib/form'
import Select from '@UI/antd/Select/Select'
import { RootState } from '@store/store'
import styles from './index.scss'

const PhoneCountryList = () => {
    const countries = useSelector((state: RootState) => state.countries.list.data)
    const filterOption = (input, option) =>
        ((option?.label || '+' + option?.value || option.props.children.toString()) ?? '')
            .toLowerCase()
            .includes(input.toLowerCase())

    return (
        <Form.Item name="prefix" noStyle>
            <Select
                showSearch
                popupMatchSelectWidth={false}
                popupClassName={styles.contry_list}
                className={styles.country_field}
                filterOption={filterOption}
            >
                {countries.map(item => (
                    <Select.Option key={item._id} value={item?.callingCodes?.[0] || ''}>
                        <div className={styles.flag}>
                            {item.flag ? <img src={item.flag} /> : <span>{item?.isoCode?.[0]}</span>}
                        </div>

                        <span>+{item?.callingCodes?.[0]}</span>
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    )
}

export default PhoneCountryList
